import { organisationConstants } from '../../_constants/organisation.constants';

const initialState = { loading : true, admins: '', error: false};

export function organisationAdmins(state = initialState, action) {
    switch (action.type) {
      case organisationConstants.REQUEST_ORG_ADMIN:
        return {
          loading: true,
          admins: '',
          error: false
        };
      case organisationConstants.RECEIVE_ORG_ADMIN:
        return {
          loading: false,
          admins: action.organisationAdmins.data.organisation_admin_list,
          error: false
        };
      case organisationConstants.ADMIN_ORG_ERROR:
        return { 
          loading: false,
          admins: '',
          error: true
        };
      default:
        return state
    }
}


// WEBPACK FOOTER //
// ./src/_reducers/organisation/admins.reducer.js